<template>
  <div class="setup-container">
    <div class="progress-bar">
      <div class="progress-side-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-document" />
        </div>
        <div class="progress-content">Step 01</div>
      </div>
      <div class="progress-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-data-analysis" />
        </div>
        <div class="progress-content">Step 02</div>
      </div>
      <div class="progress-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-bank-card" />
        </div>
        <div class="progress-content">Step 03</div>
      </div>
      <div class="progress-side-line progress-active"></div>
    </div>

    <div class="payments-wrapper">
      <div class="title">Connect to Payments</div>
      <div class="grids">
        <div class="grid" @click="goPayments">
          <img :src="paypalImage" />
        </div>
        <div class="grid" @click="goPayments">
          <img :src="iepayImage" />
        </div>
      </div>
    </div>
    <div class="bottom-buttons">
      <div @click="goSettings">Go to settings</div>
      <div @click="$emit('forbid')">Don't show again</div>
    </div>
  </div>
</template>

<script>
import paypalImage from '@/components/SetupSteps/img/paypal-payment.png'
import iepayImage from '@/components/SetupSteps/img/iepay-payment.png'

export default {
  name: 'SetupPayments',
  data() {
    return {
      paypalImage,
      iepayImage
    }
  },
  created() {
    this.shopName = this.$store.state.shop.display_shop_name
  },
  methods: {
    goPayments() {
      this.$router.push({
        name: 'PaymentMethodManagement'
      })
      this.$emit('close')
    },
    goSettings() {
      this.$router.push({
        name: 'ShopDetail'
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.setup-container {
  text-align: center;

  .progress-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    margin-bottom: 60px;

    .progress-active {
      background-color: #95bf47 !important;
    }
    .progress-line {
      flex-basis: 200px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-side-line {
      flex-basis: 100px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-main {
      position: relative;

      .progress-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.15);
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      .progress-content {
        position: absolute;
        width: 50px;
        height: 22px;
        bottom: -36px;
      }
    }
  }
  .payments-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 960px;
    margin: 0 auto;
    .title {
      height: 28px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 28px;
    }
    .grids {
      margin-top: 48px;
      display: flex;
      .grid {
        width: 386px;
        height: 211px;
        background: #FFFFFF;
        box-shadow: 0px 10px 10px -3px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        padding: 16px;
        cursor: pointer;
        &:last-of-type {
          margin-left: 24px;
        }
        &:hover {
          width: 386px;
          height: 211px;
          background: #FFFFFF;
          box-shadow: 0px 10px 10px -3px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
          border: 2px solid rgba(149, 191, 71, 0.2);
        }

        img {
          width: 354px;
          height: 180px;
        }
      }
    }
  }

  .bottom-buttons {
    margin: 0 auto;
    margin-top: 32px;
    margin-bottom: 32px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    div:first-child {
      width: 160px;
      height: 40px;
      line-height: 40px;
      background: #95bf47;
      border-radius: 20px;
      color: #fff;
      cursor: pointer;
      margin-right: 24px;
      margin-left: 90px;
    }
    div:last-child {
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      text-decoration: underline;
      color: rgba(0, 0, 0, 0.65);
      line-height: 24px;
      cursor: pointer;
    }
  }
}
</style>
